.container {
  pointer-events: none;
}

.overlay {
  background: var(--color-backdrop-subtle);
  opacity: 1;
  pointer-events: none;
  animation: overlayShow 150ms ease-out;
}

.portal {
  pointer-events: none;
}

.window {
  --color-background: var(--color-window-background);
  --color-background-2: var(--color-window-background);
  --color-background-3: var(--color-window-surface);
  --color-card: var(--color-window-card);
  --color-card-hover: color-mix(in srgb, var(--color-window-card) 82%, white);
  --color-surface-subtle: var(--color-window-surface);
  --color-surface-raised: var(--color-window-card);
  --color-foreground: var(--color-window-foreground);
  --color-muted: var(--color-window-muted);
  --color-muted-foreground: var(--color-window-muted-foreground);
  --color-border: var(--color-window-border);
  --color-control-border: var(--color-window-control-border);

  position: absolute;
  inset-inline-end: 1.5rem;
  bottom: 1.5rem;
  width: min(68rem, calc(100vw - 3rem));
  height: min(48rem, calc(100dvh - 3rem));
  max-width: calc(100vw - 3rem);
  max-height: calc(100dvh - 3rem);
  gap: 0;
  padding: 0;
  border-color: var(--color-window-control-border);
  border-radius: var(--radius-xl);
  background: var(--color-window-card);
  color: var(--color-window-foreground);
  box-shadow: var(--shadow-2xl);
  pointer-events: auto;
  transition:
    width 180ms ease,
    height 180ms ease;
}

@keyframes overlayShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.window.minimized {
  bottom: 0;
  width: min(22rem, calc(100vw - 3rem));
  height: auto;
  border-bottom: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
}

.titlebar {
  display: flex;
  min-height: 3.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-block: 0.625rem;
  padding-inline: 1rem 0.75rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-subtle);
}

.minimized .titlebar {
  border-bottom: 0;
}

.heading {
  flex: 1;
  min-width: 0;
}

.title {
  display: block;
  overflow: hidden;
  padding-inline-end: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description {
  overflow: hidden;
  margin-top: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.minimized .description {
  display: none;
}

.controls {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.125rem;
}

.controls button,
.controls a {
  color: var(--color-muted);
}

.controls button:hover,
.controls a:hover {
  color: var(--color-foreground);
}

.content {
  position: relative;
  min-height: 0;
  flex: 1;
  background: var(--color-background);
}

.iframe {
  width: 100%;
  height: 100%;
  border: 0;
  transition: opacity 300ms ease;
}

.actions {
  flex: 0 0 auto;
  margin-top: 0;
  padding: 0.625rem 1rem;
  background: var(--color-card);
}

.minimized .content,
.minimized .actions {
  display: none;
}

@media (max-width: 640px) {
  .window {
    inset-inline-end: 0.75rem;
    bottom: 0.75rem;
    width: calc(100vw - 1.5rem);
    height: calc(100dvh - 1.5rem);
    max-width: calc(100vw - 1.5rem);
    max-height: calc(100dvh - 1.5rem);
  }

  .window.minimized {
    bottom: 0;
    width: calc(100vw - 1.5rem);
  }
}
